import { createSlice } from "@reduxjs/toolkit";
import { mergeObj } from "utils/common-util";
import { handleErrorStopLoading, handleLoading, handleFail } from "redux/redux-util";

const initialState = {
  loading: false,
  questionList: [],
  page: "",
  profileRegister: {},
  error: null,
};

const slice = createSlice({
  initialState,
  name: "register",
  reducers: {
    searchQuestion: handleLoading,
    searchQuestionSuccess: (state, action) => {
      state.loading = false;
      state.questionList = action.payload;
    },
    searchQuestionFailure: handleErrorStopLoading,

    getInitInfoRegister: handleLoading,
    getInitInfoRegisterSuccess: (state, action) => {
      state.loading = false;
      state.profileRegister = mergeObj(state.profileRegister, action.payload);
    },
    getInitInfoRegisterFailure: handleFail,

    onRegister: () => {},
    onRegisterSuccess: (state, action) => {
      state.loading = false;
    },
    onRegisterFailure: handleFail,

    onUpdateProfile: () => {},
    onUpdateProfileSuccess: (state, action) => {
      state.loading = false;
    },
    onUpdateProfileFailure: handleFail,

    onSubmitSuitability: () => {},
    onSubmitSuitabilitySuccess: (state, action) => {
      state.loading = false;
    },
    onSubmitSuitabilityFailure: handleFail,

    onchangeData: (state, action) => {
      state.profileRegister = mergeObj(state.profileRegister, action.payload);
    },
    onSubmitRiskResult: (state, action) => {
      state.page = mergeObj(state.page, action.payload);
    },
    pageDirect: (state, action) => {
      state.page = action.payload;
    },
    getProfileCBS: (state, action) => {
      state.profileCBS = action.payload;
    },
    resetError: (state) => {
      state.error = null;
    },
  },
});

export const {
  searchQuestion,
  searchQuestionSuccess,
  searchQuestionFailure,
  /////////
  getDefaultRegister,
  getDefaultRegisterSuccess,
  getDefaultRegisterFailure,

  onRegister,
  onRegisterSuccess,
  onRegisterFailure,

  getInitInfoRegister,
  getInitInfoRegisterSuccess,
  getInitInfoRegisterFailure,

  onSubmitSuitability,
  onSubmitSuitabilitySuccess,
  onSubmitSuitabilityFailure,

  onUpdateProfile,
  onUpdateProfileSuccess,
  onUpdateProfileFailure,

  /////////
  onchangeData,
  pageDirect,
  onSubmitRiskResult,
  getProfileCBS,

  resetError,
} = slice.actions;

export default slice.reducer;
